import { getApp } from "firebase/app"
import { getAuth } from "firebase/auth"
import { useEffect, useState } from "react"

const useAuth = () => {
  const [auth, setAuth] = useState()
  useEffect(() => {
    setAuth(getAuth(getApp()))
  }, [])
  return auth
}

export default useAuth
